export enum ReviewSection3Step {
    REVIEW = 'REVIEW',
    COMPLETION = 'COMPLETION'
}



// WEBPACK FOOTER //
// ./src/models/remote-representative/review-section3-step.ts